import { yupResolver } from "@hookform/resolvers/yup";
import LoadingTableNormal from "components/shared-components/LoadingTableNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  resetSearchInvoiceErrorInvoices,
  searchInvoiceErrorInvoices,
} from "store/actions";
import * as yup from "yup";
import {
  IS_POS_LABEL,
  KyHieuMauHoaDonList,
  invoiceTypeMode,
  tableFormateDate,
} from "./utils";

const SearchInvoice = props => {
  const {
    isPos,
    isOpenModal,
    toggleModal,
    dataSearchInvoice,
    setDataSearchInvoice,
    addNewLine,
    isCheckIsPos,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["errorInvoice"]);
  const { addToast } = useToasts();

  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    loadingSearchInvoice,
    errorSearchInvoice,
    searchInvoice: errorInvoicesSearchInvoice,
  } = errorInvoices;

  const Dashboard = useSelector(state => state.Dashboard);
  const { listBuOfTenant, listBuStore } = Dashboard;

  const [resultSearch, setResultSearch] = useState(null);

  const schema = yup.object().shape({
    khmhdon: yup.object(),
    khhdon: yup
      .string()
      .required(t("form.validate.required", { title: t("form.khhdon") }))
      .max(100, t("form.validate.char_max", { max: 100 })),
    shdon: yup
      .string()
      .required(t("form.validate.required", { title: t("form.so_hoa_don") }))
      .matches(/^[0-9]+$/, t("form.validate.integer")),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      khmhdon: undefined,
      khhdon: "",
      shdon: "",
    },
  });

  // Modal Closed
  useEffect(() => {
    if (!isOpenModal) {
      setResultSearch(null);
      reset({
        khmhdon: undefined,
        khhdon: "",
        shdon: "",
      });
      dispatch(resetSearchInvoiceErrorInvoices());
    }
  }, [dispatch, isOpenModal]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesSearchInvoice && errorInvoicesSearchInvoice.success) {
      if (errorInvoicesSearchInvoice.data) {
        setResultSearch(errorInvoicesSearchInvoice.data);
      }
      dispatch(resetSearchInvoiceErrorInvoices());
    }
  }, [dispatch, errorInvoicesSearchInvoice]);

  // Error Dispatch
  useEffect(() => {
    if (errorSearchInvoice) {
      if (
        errorSearchInvoice.status &&
        errorSearchInvoice.status === "NOT_FOUND"
      ) {
      } else {
        addToast(
          formConvertErrorMessage(
            errorSearchInvoice.message ||
              t("message.search_invoice", {
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }
    }
  }, [addToast, errorSearchInvoice, t]);

  const onSubmit = values => {
    dispatch(
      searchInvoiceErrorInvoices({
        khmhdon: values.khmhdon.value,
        khhdon: values.khhdon,
        shdon: values.shdon,
        is_pos: isPos,
      })
    );
    setResultSearch(null);
  };

  const khmhdonHandler = () => {
    let khhdonPrefix = "";
    const ye = new Intl.DateTimeFormat("en", { year: "2-digit" }).format(
      new Date()
    );

    const buTenant = localStorage.getItem("BU_STORE_HEADER");
    let value = null;
    let dataBu = null;
    if (listBuStore && listBuStore.length > 0) {
      value = listBuStore.find(item => item.value === buTenant);
      dataBu = value;
    } else {
      value = listBuOfTenant.find(item => item.code === buTenant);
      dataBu = value && value.itemBU;
    }

    switch (String(dataBu?.invoice_type)) {
      case invoiceTypeMode.NONE_CODE:
        khhdonPrefix += "K";
        break;
      case invoiceTypeMode.HAVE_CODE:
        khhdonPrefix += "C";
        break;
      default:
        break;
    }

    khhdonPrefix += String(ye);

    const khmhdonValue = getValues("khmhdon");
    const prefixFind = KyHieuMauHoaDonList.find(
      item => item.value === khmhdonValue.value
    );
    if (prefixFind) {
      khhdonPrefix += isPos ? "M" : prefixFind.prefix;
    }

    setValue("khhdon", khhdonPrefix, { shouldValidate: true });
    setFocus("khhdon");
  };

  const addToInvoiceListHandler = () => {
    const resultFind = dataSearchInvoice.find(
      item => item.id === resultSearch.id
    );
    if (resultFind) {
      addToast("Hóa đơn này đã được thêm vào", {
        appearance: "warning",
        autoDismiss: true,
      });
    } else {
      // Check k cho thêm HĐ khác loại áp dụng
      if (
        isCheckIsPos &&
        dataSearchInvoice?.length > 0 &&
        isPos !== Number(dataSearchInvoice[0]?.is_pos)
      ) {
        addToast("Loại áp dụng HĐ không hợp lệ, vui lòng chọn loại khác", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }
      addToast("Thêm vào danh sách thành công", {
        appearance: "success",
        autoDismiss: true,
      });
      setDataSearchInvoice([...dataSearchInvoice, resultSearch]);

      const khmhdonFind = KyHieuMauHoaDonList.find(
        item => item.value === resultSearch.ttchung_khmshdon
      );

      const dateNgayLap =
        resultSearch.ttchung_nlap &&
        new Date(Number(resultSearch.ttchung_nlap) * 1000).toString() !==
          "Invalid Date"
          ? [new Date(Number(resultSearch.ttchung_nlap) * 1000)]
          : [];

      addNewLine({
        is_pos: isPos,
        id_invoice: resultSearch.id,
        ma_cqt_cap: resultSearch.mccqt,
        khmhdon: khmhdonFind
          ? khmhdonFind
          : resultSearch.ttchung_khmshdon
          ? {
              value: resultSearch.ttchung_khmshdon,
              label: resultSearch.ttchung_khmshdon,
            }
          : undefined,
        khhdon: resultSearch.ttchung_khhdon,
        so_hoa_don: Number(resultSearch.ttchung_shdon),
        ngay_lap_hdon: dateNgayLap,
        tchat_thong_bao: undefined,
        ly_do: "",
        CHANGES: {
          nmua_dchi_old: resultSearch?.nmua_dchi,
          nmua_dchi_new: "",
        },
      });
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        contentClassName="select-job-modal"
        className="exampleModal"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            Tìm kiếm {isPos ? IS_POS_LABEL[1] : IS_POS_LABEL[0]}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="khmhdon">{t("form.khmhdon")}</Label>
                  <Controller
                    control={control}
                    name="khmhdon"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: t("form.khmhdon"),
                        })}
                        options={
                          KyHieuMauHoaDonList && KyHieuMauHoaDonList.length > 0
                            ? KyHieuMauHoaDonList?.filter(k =>
                                isPos ? k.value !== "6" : k
                              ).map(item => ({
                                value: item.value,
                                label: item.label,
                              }))
                            : []
                        }
                        onChange={data => {
                          field.onChange(data);
                          khmhdonHandler();
                        }}
                        classNamePrefix="select2-selection"
                      />
                    )}
                  />
                  {errors.khmhdon && (
                    <MessageFormValidate error={errors.khmhdon.message} />
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="khhdon">
                    {t("form.khhdon")} <span className="text-danger">*</span>
                  </Label>
                  <Controller
                    control={control}
                    name="khhdon"
                    render={({ field }) => (
                      <input
                        {...field}
                        maxLength={6}
                        className={`form-control ${formValidate(
                          errors,
                          touchedFields,
                          "khhdon"
                        )}`}
                        onChange={data => {
                          field.onChange(data.target.value.toUpperCase());
                        }}
                        placeholder={t("placeholder.enter", {
                          title: t("form.khhdon"),
                        })}
                      />
                    )}
                  />
                  {errors.khhdon && (
                    <MessageFormValidate error={errors.khhdon.message} />
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="shdon">
                    {t("form.shdon")} <span className="text-danger">*</span>
                  </Label>
                  <input
                    type="number"
                    className={`form-control ${formValidate(
                      errors,
                      touchedFields,
                      "shdon"
                    )}`}
                    placeholder={t("placeholder.enter", {
                      title: t("form.shdon"),
                    })}
                    {...register("shdon")}
                  />
                  {errors.shdon && (
                    <MessageFormValidate error={errors.shdon.message} />
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-end">
              <Col className="col-auto">
                <Button
                  color="success"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  <i className="fas fa-search label-icon" />
                  {t("form.search")}
                </Button>
              </Col>
            </Row>
            <Row className="row-cols-1">
              <Col>
                <Label className="fw-bold">Kết quả:</Label>
              </Col>
              {loadingSearchInvoice ? (
                <LoadingTableNormal countColumn="4" countRow="1" />
              ) : resultSearch && Object.keys(resultSearch).length > 0 ? (
                <React.Fragment>
                  <Col>
                    <Table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Loại áp dụng</th>
                          <th>Mã CQT cấp</th>
                          <th>Ký hiệu</th>
                          <th>Số HĐ</th>
                          <th>Ngày lập HĐ</th>
                          <th>Địa chỉ người mua</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{IS_POS_LABEL[isPos]}</td>
                          <td>{resultSearch.mccqt}</td>
                          <td style={{ width: "100px" }}>
                            {resultSearch.ttchung_khmshdon +
                              resultSearch.ttchung_khhdon}
                          </td>
                          <td style={{ width: "70px" }}>
                            {resultSearch.ttchung_shdon}
                          </td>
                          <td style={{ width: "120px" }}>
                            {tableFormateDate(resultSearch.ttchung_nlap)}
                          </td>
                          <td>{resultSearch.nmua_dchi}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col className="text-center">
                    <button
                      type="button"
                      className="btn btn-primary btn-label"
                      onClick={addToInvoiceListHandler}
                    >
                      <i className="fas fa-plus fa-lg label-icon" />
                      Thêm vào danh sách hóa đơn
                    </button>
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {errorSearchInvoice &&
                    errorSearchInvoice.status &&
                    errorSearchInvoice.status === "NOT_FOUND" && (
                      <Col>
                        <div className="alert alert-warning" role="alert">
                          <span className="pe-1">
                            <i className="fas fa-exclamation-circle fa-lg"></i>
                          </span>
                          <span>Không tìm thấy hóa đơn</span>
                        </div>
                      </Col>
                    )}
                </React.Fragment>
              )}
            </Row>

            <hr />
            <Row className="row-cols-1">
              <Col>
                <Label className="fw-bold">Danh sách hóa đơn đã chọn :</Label>
              </Col>
              {dataSearchInvoice && dataSearchInvoice.length > 0 ? (
                <React.Fragment>
                  <Col>
                    <Table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Loại áp dụng</th>
                          <th>Mã CQT cấp</th>
                          <th>Ký hiệu</th>
                          <th>Số HĐ</th>
                          <th>Ngày lập HĐ</th>
                          <th>Địa chỉ người mua</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataSearchInvoice.map(item => {
                          return (
                            <tr key={item.id}>
                              <td>
                                {isCheckIsPos
                                  ? IS_POS_LABEL[item?.is_pos]
                                  : IS_POS_LABEL[isPos]}
                              </td>
                              <td>{item.mccqt}</td>
                              <td style={{ width: "100px" }}>
                                {item.ttchung_khmshdon + item.ttchung_khhdon}
                              </td>
                              <td style={{ width: "70px" }}>
                                {item.ttchung_shdon}
                              </td>
                              <td style={{ width: "120px" }}>
                                {tableFormateDate(item.ttchung_nlap)}
                              </td>
                              <td>{item.nmua_dchi}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Col>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Col>
                    <div className="alert alert-info" role="alert">
                      <span className="pe-1">
                        <i className="fas fa-exclamation-circle fa-lg"></i>
                      </span>
                      <span>Chưa có hóa đơn nào được chọn</span>
                    </div>
                  </Col>
                </React.Fragment>
              )}
            </Row>
          </ModalBody>
          <ModalFooter>
            <Row className="justify-content-end">
              <Col className="col-auto">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModal}
                >
                  {t("form.close")}
                </button>
              </Col>
            </Row>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  );
};

SearchInvoice.propTypes = {
  // dataDetail: PropTypes.object.isRequired,
  isPos: PropTypes.any,
  isCheckIsPos: PropTypes.bool,
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataSearchInvoice: PropTypes.array.isRequired,
  setDataSearchInvoice: PropTypes.func.isRequired,
  addNewLine: PropTypes.func.isRequired,
};

SearchInvoice.defaultProps = {
  // dataDetail: {},
  isCheckIsPos: true,
  isOpenModal: false,
  dataSearchInvoice: [],
};

export default SearchInvoice;
